export default "__VITE_ASSET__BiFW1Oqs__"